










import { Prop, Component, Vue } from "vue-property-decorator";
import { Task } from "@/api/task-api";
import dayOfWeek from "@/helpers/day-of-week";
import formatDate from "../../helpers/formatDate";
import formatTime from "../../helpers/formatTime";

@Component({
  components: {}
})
export default class VTask extends Vue {
  @Prop({ required: true }) task!: Task;

  get closedDays(): string {
    const closedDays = this.task.closedDays.map(dayOfWeek).join("・");
    return closedDays || "なし";
  }

  formatDate(d: Date) {
    return `${formatDate(d)} ${formatTime(d)}`;
  }
}
